<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-down-double__a)">
    <path d="M21.735 9.709a1 1 0 0 0-1.416 0L12 18.043 3.681 9.709a1 1 0 0 0-1.416 0l-1.56 1.563a1 1 0 0 0 0 1.413l10.587 10.606a1 1 0 0 0 1.416 0l10.587-10.606a1 1 0 0 0 0-1.413l-1.56-1.563Z"/>
    <path d="M21.735.709a1 1 0 0 0-1.416 0L12 9.043 3.681.709a1 1 0 0 0-1.416 0L.705 2.272a1 1 0 0 0 0 1.413l10.587 10.606a1 1 0 0 0 1.416 0L23.295 3.685a1 1 0 0 0 0-1.413L21.735.709Z"/>
  </g>
  <defs>
    <clipPath id="chevron-down-double__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
